<script>
  import {onDestroy, onMount} from "svelte";

  import Moveable from "svelte-moveable";

  import {layers, layersInfo} from "./stores";

  export let offsetX, offsetY, layerId, layerType;

  const frame = {
    translate: [0, 0],
    rotate: 0,
    size: [200, 200],
  };

  let target;
  let posX = 0;
  let posY = 0;
  // The index this layer will be in the layers array
  let layerIdx = 0;
  let writableUnsubscribeFunctions = [];

  let mounted = false;

  onMount(() => {
    mounted = true;
    layerIdx = $layersInfo.length;
    $layersInfo.push({
          id: layerId,
          type: layerType,
          position: [posX, posY],
          dimensions: [frame.size[0], frame.size[1]],
          rotation: frame.rotate,
          transformations: [[0,0], [0,0], [0,0], [0,0]],
          font: "calibribold.ttf",
          stroke_width: 0,
          stroke_color: [0,0,0],
          align: "center",
          v_align: "center"
        });
    // This returns a function to unsubscribe from the writable
    writableUnsubscribeFunctions.push(layersInfo.subscribe(value => {

      if(value[layerIdx]?.id !== layerId){
        let newIdx = $layers.indexOf(layerId);
        if(newIdx === undefined){
          throw Error('Error syncing layer data');
        }

        layerIdx = newIdx + 1;
      }

    }));

  });

  $: {
    if (mounted) {
      let rect = target.getBoundingClientRect();
      posX = rect.left;
      posY = rect.top;
    }
  }

  $: {

    $layersInfo[layerIdx].position = frame.translate;
    $layersInfo[layerIdx].dimensions = frame.size;
    $layersInfo[layerIdx].rotation = frame.rotate;

  }

  onDestroy(() => {

    for(let unsubscribeFunction of writableUnsubscribeFunctions){

      unsubscribeFunction();
      $layersInfo.splice(layerIdx, 1);
      $layersInfo = $layersInfo;

    }

  });

</script>

<div class="target" bind:this={target}>
  <!-- <h1 class="layer-id">layer-1</h1> -->

  <div class="stats">
    <code class="layer-id-label">{layerId}</code>
    <code>
      pos: ({(frame.translate[0] + posX - offsetX).toFixed()}, {(
        frame.translate[1] +
        posY -
        offsetY +
        15
      ).toFixed()})
    </code>
    <code>rot: {frame.rotate.toFixed(1)}</code>
    <code>dims: ({frame.size[0].toFixed()}, {frame.size[1].toFixed()})</code>
  </div>
</div>

<Moveable
  {target}
  draggable={true}
  throttleDrag={0}
  on:dragStart={({ detail: { set } }) => {
    set(frame.translate);
  }}
  on:drag={({ detail: { target, beforeTranslate } }) => {
    frame.translate = beforeTranslate;
    target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) rotate(${frame.rotate}deg)`;
  }}
  on:dragEnd={({ detail: { target, isDrag, clientX, clientY } }) => {
    console.log("onDragEnd", target, isDrag);

    console.log(frame.translate, frame.rotate, frame.size);
  }}
  resizable={true}
  throttleResize={0}
  on:resizeStart={({ detail: { target, set, setOrigin, dragStart } }) => {
    // Set origin if transform-origin use %.
    setOrigin(["%", "%"]);

    // If cssSize and offsetSize are different, set cssSize. (no box-sizing)
    const style = window.getComputedStyle(target);
    const cssWidth = parseFloat(style.width);
    const cssHeight = parseFloat(style.height);
    set([cssWidth, cssHeight]);

    // If a drag event has already occurred, there is no dragStart.
    dragStart && dragStart.set(frame.translate);
  }}
  on:resize={({ detail: { target, width, height, drag } }) => {
    target.style.width = `${width}px`;
    target.style.height = `${height}px`;

    frame.size = [width, height];
    // get drag event
    frame.translate = drag.beforeTranslate;
    target.style.transform = `translate(${drag.beforeTranslate[0]}px, ${drag.beforeTranslate[1]}px) rotate(${frame.rotate}deg)`;
  }}
  on:resizeEnd={({ detail: { target, isDrag, clientX, clientY } }) => {
    console.log("onResizeEnd", target, isDrag);
  }}
  rotatable={true}
  throttleRotate={0}
  rotationPosition="top"
  on:rotateStart={({ detail: { set } }) => {
    set(frame.rotate);
  }}
  on:rotate={({ detail: { target, beforeRotate } }) => {
    frame.rotate = beforeRotate;
    target.style.transform = `translate(${frame.translate[0]}px, ${frame.translate[1]}px) rotate(${beforeRotate}deg)`;
  }}
  on:rotateEnd={({ detail: { target, isDrag, clientX, clientY } }) => {
    console.log("onRotateEnd", target, isDrag);
  }}
/>

<style>
  .target {
    height: 200px;
    width: 200px;
    color: white;
    background-color: rgba(255, 255, 255, 0.32);
    position: fixed;
    /* align-items: center; */
  }

  .stats {
    width: 150px;
    top: -6rem;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .stats-2 {
    color: gray;
    width: 150px;
    bottom: -6rem;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .layer-id {
    font-size: 1rem;
  }

  .layer-id-label{
    font-size: 1.25rem;
  }

</style>
